/**
 * @generated SignedSource<<1b69269c8765b7df26ae09139684ce89>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentsMethodsListDrawer_PaymentOptionConnection$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PaymentsMethodsListContentStep_PaymentOptionConnection" | "PaymentMethodInfoStep_PaymentOptionConnection">;
  readonly " $fragmentType": "PaymentsMethodsListDrawer_PaymentOptionConnection";
};
export type PaymentsMethodsListDrawer_PaymentOptionConnection$key = {
  readonly " $data"?: PaymentsMethodsListDrawer_PaymentOptionConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentsMethodsListDrawer_PaymentOptionConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentsMethodsListDrawer_PaymentOptionConnection",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentsMethodsListContentStep_PaymentOptionConnection"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentMethodInfoStep_PaymentOptionConnection"
    }
  ],
  "type": "PaymentOptionConnection",
  "abstractKey": null
};

(node as any).hash = "158ca659d6b693ca744e57a90a8a8317";

export default node;
